module.exports = __webpack_public_path__ + "static/media/lemon-906141_1280.afbfab24.jpg";